<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->
<template>
    <div class="min-h-screen bg-gray-50">
    <div class="mx-auto max-w-7xl px-4 py-8">
    <!-- 产品类型选择 -->
    <div class="mb-8">
    <h2 class="mb-6 text-xl font-medium">选择产品类型</h2>
    <div class="grid grid-cols-8 gap-4">
    <div v-for="(type, index) in productTypes" :key="index"
    class="flex flex-col items-center p-2 rounded-lg hover:bg-gray-100 relative">
    <div class="absolute top-2 right-2 cursor-pointer" @click="selectType(index)">
    <i class="fas fa-square-check text-2xl" :class="selectedTypes.includes(index) ? 'text-blue-500' : 'text-gray-200'"></i>
    </div>
    <div class="w-20 h-20 mb-2 rounded-full bg-white shadow-sm overflow-hidden cursor-pointer" @click="previewType(index)">
    <img :src="type.image" class="w-full h-full object-cover" :alt="type.name"/>
    </div>
    <div class="text-center cursor-pointer" @click="previewType(index)">
    <p class="text-sm mb-1">{{ type.name }}</p>
    <p class="text-xs text-gray-500">{{ type.size }}</p>
    </div>
    </div>
    </div>
    </div>
    <!-- 产品盒子类型 -->
    <div class="mb-8" v-if="selectedType !== -1">
    <h2 class="mb-6 text-xl font-medium">选择产品盒子类型</h2>
    <div class="flex gap-4">
    <div v-for="(box, index) in getBoxTypes"
    :key="index"
    class="px-6 py-2 border !rounded-button whitespace-nowrap cursor-pointer"
    :class="{'border-blue-500 text-blue-500': selectedBox === index, 'border-gray-300': selectedBox !== index}"
    @click="selectedBox = index">
    {{ box }}
    </div>
    </div>
    </div>
    <!-- 文件上传 -->
    <div class="mb-8">
    <h2 class="mb-2 text-xl font-medium">上传设计文件</h2>
    <p v-if="selectedTypes.length === 0 || selectedBox === -1" class="text-gray-500 mb-4">请先选择产品类型和盒子类型</p>
    <template v-else>
    <p class="text-gray-500 mb-4">当前选择: {{ selectedTypesText }} - {{ getBoxTypes[selectedBox] }}</p>
    <div class="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center cursor-pointer hover:border-blue-500"
    @click="handleUpload">
    <div class="flex flex-col items-center justify-center">
    <i class="fas fa-plus text-3xl text-gray-400 mb-2"></i>
    <p class="text-gray-500">点击或拖拽文件到此处上传</p>
    </div>
    <input type="file" class="hidden" ref="fileInput" @change="onFileChange"
    accept=".cdr,.ocr,.jpg,.jpeg,.png"/>
    </div>
    </template>
    </div>
    </div>
    </div>
    </template>
    <script>
    export default {
    name: 'App',
    data() {
    return {
    selectedTypes: [],
    selectedBox: -1,
    productTypes: Array(16).fill().map((_, index) => ({
    name: `标准尺寸${index + 1}`,
    size: '9 × 9cm',
    image: `https://mastergo.com/ai/api/search-image?query=A minimalist product box icon design with simple geometric shapes and clean lines, featuring a modern and professional aesthetic against a light gray background&width=200&height=200&orientation=squarish&flag=1c8c935b1cb26ae4231bf87a3b485d39`
    })),
    boxTypesList: [
    ['A型-样式1', 'A型-样式2', 'A型-样式3'],
    ['B型-样式1', 'B型-样式2', 'B型-样式3', 'B型-样式4'],
    ['C型-样式1', 'C型-样式2'],
    ['D型-样式1', 'D型-样式2', 'D型-样式3', 'D型-样式4', 'D型-样式5'],
    ],
    };
    },
    computed: {
    getBoxTypes() {
    if (this.selectedTypes.length === 0) return [];
    return this.boxTypesList[this.selectedTypes[0] % this.boxTypesList.length];
    },
    selectedTypesText() {
    return this.selectedTypes.map(index => this.productTypes[index].name).join(', ');
    }
    },
    methods: {
    selectType(index) {
    const typeIndex = this.selectedTypes.indexOf(index);
    if (typeIndex === -1) {
    this.selectedTypes.push(index);
    } else {
    this.selectedTypes.splice(typeIndex, 1);
    }
    this.selectedBox = -1;
    },
    previewType(index) {
    // 这里可以添加预览逻辑，比如打开预览弹窗等
    console.log('Preview type:', index);
    },
    handleUpload() {
    this.$refs.fileInput.click();
    },
    onFileChange(event) {
    const file = event.target.files[0];
    if (file) {
    // 处理文件上传逻辑
    const productTypes = this.selectedTypes.map(index => this.productTypes[index].name);
    const boxType = this.getBoxTypes[this.selectedBox];
    console.log('Selected file:', file.name);
    console.log('Product Types:', productTypes);
    console.log('Box Type:', boxType);
    }
    }
    }
    };
    </script>
    <style scoped>
    .grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
    }
    input[type="file"] {
    display: none;
    }
    </style>
    


// WEBPACK FOOTER //
// src/views/store/placeorder/index copy.vue